module.exports = __webpack_public_path__ + "static/media/20gb.4afb2fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/20gb.png
// module id = 77
// module chunks = 0